import { CandidateUIV2Layout } from '../../layout/candidateUIV2/CandidateUIV2Layout';
import { HomePage } from '../../components/UIV2/pages/homePageUIV2/HomePage';
import { NextSeo } from 'next-seo';
import Utils from '../../utils/Utils';
import { DEFAULT_OG_IMAGES, SEO_COMMON } from '../../layout/candidate/CandidateLayout';
import { SSRPage } from '../../components/SSRPage/SSRPage';

export const Home: SSRPage<any> = () => {
  return (
    <CandidateUIV2Layout
      title={
        <NextSeo
          canonical="https://www.hotjobs.lk/"
          title={`Jobs in Sri Lanka | Job Vacancies in ${Utils.moment().format('YYYY')} | HotJobs`}
          description="HotJobs is the most popular jobs portal in Sri Lanka. Find top job vacancies in Sri Lanka & foreign employment opportunities for your career growth."
          additionalMetaTags={[
            {
              name: 'keywords',
              content:
                'Jobs in Sri Lanka, Job Vacancies, Job Vacancies at colombo, Sri Lanka job vacancies, Jobs vacancy Sri Lanka, Part time job in Sri Lanka, Online jobs Sri Lanka',
            },
          ]}
          openGraph={{
            title: `Jobs in Sri Lanka | Job Vacancies in ${Utils.moment().format(
              'YYYY',
            )} | HotJobs`,
            description:
              'HotJobs is the most popular jobs portal in Sri Lanka. Find top job vacancies in Sri Lanka & foreign employment opportunities for your career growth.',
            images: DEFAULT_OG_IMAGES,
          }}
          {...SEO_COMMON}
        />
      }>
      <HomePage />
    </CandidateUIV2Layout>
  );
};
Home.getInitialProps = async () => {
  try {
    // return {};
    // if (connection.token) {
    //   return { dashboard: true };
    // }
    // const landingPageData = await Utils.getLandingPageData();
    // if (landingPageData) {
    //   return landingPageData;
    // }
    // return await connection.get(`home/landing`);
    return {};
  } catch (e) {
    return null;
  }
};
